export const TEAMC_3228_FLAG = 'TEAMC_3228-new-practice-problems';
export enum TEAMC_3228_FLAG_VARIANTS {
  CONTROL = 'control',
  TREATMENT_1 = 'treatment-1',
  TREATMENT_2 = 'treatment-2',
}
